/* Auto Generated */

export enum LicenceType {
	user = 229380000,
	server = 229380001,
	service = 229380002,
	connector = 229380003,
}
